var $2516f8bc94df6b6f$exports = {};
$2516f8bc94df6b6f$exports = {
    "collectionLabel": `Ieteikumi`
};


export {$2516f8bc94df6b6f$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
